<template>
  <button class="btn btn-outline-primary" @click="csvExport(data)">
    Download chart data
  </button>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ExportModule",
  props: ["data"],
  methods: {
    convertArrayOfObjectsToCSV(args) {
      var result, columnDelimiter, lineDelimiter, data;
      data = args.data;
      columnDelimiter = ",";
      lineDelimiter = "\n";
      result = "";
      data.forEach(function (item) {
        Object.keys(item).forEach((key) => {
          if (key === "breakdown" || key === "name") {
            result += item[key] + lineDelimiter;
          } else {
            result +=
              columnDelimiter +
              key +
              columnDelimiter +
              item[key] +
              lineDelimiter;
          }
        });
      });
      return result;
    },
    csvExport(arrData) {
      var data, filename, link;
      var csv = this.convertArrayOfObjectsToCSV({
        data: arrData,
      });
      if (csv == null) return;
      filename = arrData.filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
  },
});
</script>

<style scoped></style>
